import React from 'react'

type ParkingProps = {
  className?: string
}

const _Parking = (props: ParkingProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM11.5 11H10V8H11.5C12.3284 8 13 8.67157 13 9.5C13 10.3284 12.3284 11 11.5 11ZM10 13V16H8V13V6H10H11.5C13.433 6 15 7.567 15 9.5C15 11.433 13.433 13 11.5 13H10Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_Parking)
